import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_1 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ScrollerList/ScrollerItem.vue';
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ScrollerList/index.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "page-noticeList"
  }, [_c('view-box', {
    ref: "viewBox",
    attrs: {
      "body-padding-bottom": 0
    }
  }, [_c(__unplugin_components_0, {
    ref: "noticeList",
    attrs: {
      "is-px": "",
      "size": "normal",
      "circle-image": false,
      "height": _vm.scrollerHight
    },
    on: {
      "on-pulldown-loading": _vm.onPulldownLoading,
      "on-pullup-loading": _vm.onPullupLoading
    }
  }, [_c('group', {
    attrs: {
      "title": i18n.tc("477")
    }
  }), _vm._l(_vm.List, function (item, index) {
    return _c(__unplugin_components_1, {
      key: index,
      attrs: {
        "value": index
      },
      nativeOn: {
        "click": function ($event) {
          _vm.$router.push({
            name: 'NoticeDetail',
            params: {
              id: parseInt(item.id)
            }
          });
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(" " + _vm._s(item.title) + " ")]), _c('div', {
      attrs: {
        "slot": "extra"
      },
      slot: "extra"
    }, [_c('div', {
      staticStyle: {
        "display": "flex",
        "justify-content": "space-between"
      }
    }, [_c('span', [_vm._v(i18n.tc("476") + _vm._s(item.create_time))])])]), _c('div', {
      attrs: {
        "slot": "content"
      },
      slot: "content"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])]);
  })], 2)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };